/**
 * Collection product tiles — Load more / Show less (in-section pagination).
 */
(function () {
  'use strict';

  function initRoot(root) {
    if (!root || root.__cpdMoreInit) return;
    var grid = root.querySelector('[data-cpd-grid]');
    var moreBtn = root.querySelector('[data-cpd-more]');
    var lessBtn = root.querySelector('[data-cpd-less]');
    var shownEl = root.querySelector('[data-cpd-shown]');
    var totalEl = root.querySelector('[data-cpd-total]');
    if (!grid || !moreBtn) return;
    root.__cpdMoreInit = true;

    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-cpd-page]'));
    if (!items.length) {
      moreBtn.hidden = true;
      if (lessBtn) lessBtn.hidden = true;
      return;
    }

    var maxPage = 1;
    items.forEach(function (el) {
      var n = parseInt(el.getAttribute('data-cpd-page'), 10) || 1;
      if (n > maxPage) maxPage = n;
    });

    var current = 1;
    var batch = parseInt(root.getAttribute('data-cpd-batch'), 10) || 24;

    function refreshLazy(scope) {
      if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.checkElems === 'function') {
        window.lazySizes.loader.checkElems();
        return;
      }
      Array.prototype.forEach.call(scope.querySelectorAll('img.lazyload[data-src]'), function (img) {
        var src = img.getAttribute('data-src');
        if (src && !img.getAttribute('src')) img.setAttribute('src', src);
      });
    }

    function updateMeta() {
      var visible = 0;
      items.forEach(function (el) {
        if (!el.hasAttribute('hidden')) visible += 1;
      });
      if (shownEl) shownEl.textContent = String(visible);
      if (totalEl) totalEl.textContent = String(items.length);
    }

    function apply() {
      items.forEach(function (el) {
        var n = parseInt(el.getAttribute('data-cpd-page'), 10) || 1;
        if (n <= current) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
      moreBtn.hidden = current >= maxPage;
      if (lessBtn) lessBtn.hidden = current <= 1;
      updateMeta();
      refreshLazy(grid);
    }

    moreBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (current < maxPage) current += 1;
      apply();
    });

    if (lessBtn) {
      lessBtn.addEventListener('click', function (e) {
        e.preventDefault();
        current = 1;
        apply();
        try {
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (err) {
          root.scrollIntoView(true);
        }
      });
    }

    apply();
  }

  function initAll() {
    document.querySelectorAll('[data-collection-product-tiles][data-cpd-load-more]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-collection-product-tiles][data-cpd-load-more]')
      : null;
    if (root) {
      root.__cpdMoreInit = false;
      initRoot(root);
    }
  });
})();
